<template>
  <div>
    <b-container variant="primary" fluid class="p-5">
      <b-row>
        <b-col :cols="12">
          <h3>
            {{ id === 'new' ? 'Nuevo' : 'Modificando' }} producto predefinido
          </h3>

          <!-- Form -->
          <b-form @submit.stop.prevent="onSubmit">
            <b-alert :show="form.error.show" variant="danger">{{
              form.error.text
            }}</b-alert>

            <b-form-row>
              <b-form-group
                :key="lang"
                v-for="(lang, i) in languageCodes"
                :id="'input-reference_' + lang"
                :label="'Nombre (' + languageNames[i] + ')'"
                :label-for="'reference_' + lang"
                class="col-3"
              >
                <b-form-input
                  :id="'reference_' + lang"
                  v-model="$v.form['reference_' + lang].$model"
                  :state="validateStateGlobal('reference_' + lang)"
                  :aria-describedby="'input-reference_' + lang + '- feedback'"
                ></b-form-input>
                <b-form-invalid-feedback
                  :id="'input-reference_' + lang + '-feedback'"
                  >Este campo es obligatorio.</b-form-invalid-feedback
                >
              </b-form-group>
            </b-form-row>

            <b-form-row>
              <b-form-group
                :key="lang"
                v-for="(lang, i) in languageCodes"
                id="input-description"
                class="col-6"
                :label="'Descripción (' + languageNames[i] + ')'"
                :label-for="'description_' + lang"
              >
                <vue-editor
                  v-model="$v.form['description_' + lang].$model"
                ></vue-editor>

                <b-form-invalid-feedback
                  :id="'input-description' + lang + '-feedback'"
                  >Este campo es obligatorio.</b-form-invalid-feedback
                >
              </b-form-group>
            </b-form-row>

            <b-form-row>
              <b-form-group
                id="hidden-product"
                class="col-3"
                label="Ocultar en la web"
                label-for="price"
                description="Si está oculto, significa que no aparecerá en la web, y sólo estará disponible para presupuestar desde el PI."
              >
                <b-form-checkbox
                  switch
                  v-model="$v.form.hidden.$model"
                  name="input-hidden"
                  >{{ $v.form.hidden.$model ? 'Sí' : 'No' }}</b-form-checkbox
                >
              </b-form-group>
              <b-form-group
                id="input-is_discontinued"
                class="col-3"
                label="Descatalogado"
                description="No aparecerá a la hora de elaborar presupuestos"
                label-for="is_discontinued"
              >
                <b-form-checkbox
                  switch
                  v-model="$v.form.is_discontinued.$model"
                  name="input-is_discontinued"
                  >{{
                    $v.form.is_discontinued.$model ? 'Sí' : 'No'
                  }}</b-form-checkbox
                >

                <b-form-invalid-feedback id="input-is_discontinued-feedback"
                  >Este campo es obligatorio.</b-form-invalid-feedback
                >
              </b-form-group>
            </b-form-row>

            <b-form-row>
              <b-form-group
                :key="lang"
                v-for="(lang, i) in languageCodes"
                :id="'input-slug_' + lang"
                :label="'Slug (' + languageNames[i] + ')'"
                :label-for="'slug_' + lang"
                class="col-3"
              >
                <b-form-input
                  :id="'slug_' + lang"
                  v-model="$v.form['slug_' + lang].$model"
                  :state="validateStateGlobal('slug_' + lang)"
                  :aria-describedby="'input-slug_' + lang + '- feedback'"
                ></b-form-input>
                <b-form-invalid-feedback
                  :id="'input-slug_' + lang + '-feedback'"
                  >Este campo es obligatorio.</b-form-invalid-feedback
                >
              </b-form-group>
            </b-form-row>

            <b-form-row>
              <!-- Reference -->
              <!-- <b-form-group
                id="input-reference"
                class="col-3"
                label="Nombre"
                label-for="reference"
              >
                <b-form-input
                  id="reference"
                  :value="$v.form.reference.$model"
                  @change="changedName($event)"
                  :state="validateStateGlobal('reference')"
                  aria-describedby="input-reference-feedback"
                ></b-form-input>
                <b-form-invalid-feedback id="input-reference-feedback"
                  >Este campo es obligatorio.</b-form-invalid-feedback
                >
              </b-form-group> -->

              <!-- <b-form-group class="col-2" label="Precio" label-for="price">
                <b-form-input
                  id="price"
                  v-model="$v.form.price.$model"
                  :state="validateStateGlobal('price')"
                  aria-describedby="input-price-feedback"
                ></b-form-input>
                <b-form-invalid-feedback id="input-price-feedback"
                  >Este campo es obligatorio.</b-form-invalid-feedback
                >
              </b-form-group> -->

              <b-form-group
                id="input-category"
                class="col-3"
                label="Categoría"
                label-for="category"
              >
                <b-form-select
                  :options="categoryOptions"
                  id="category"
                  v-model="$v.form.category.$model"
                  :state="validateStateGlobal('category')"
                  aria-describedby="input-category-feedback"
                ></b-form-select>
                <b-form-invalid-feedback id="input-category-feedback"
                  >Este campo es obligatorio.</b-form-invalid-feedback
                >
              </b-form-group>
            </b-form-row>

            <b-form-row>
              <b-col cols="2" v-for="(v, i) in numFiles" :key="i">
                <b-row>
                  <b-form-group
                    id="input-image"
                    class="col-12"
                    :label="'Imagen y vista previa (' + (i + 1) + ')'"
                    description="Dejar vacío para mantener la imagen actual"
                    label-for="image"
                  >
                    <b-input-group>
                      <b-form-file
                        accept="image/*"
                        :id="'image' + i"
                        v-model="$v.form['image' + i].$model"
                        @input="changedImage(i, $event)"
                        :state="validateStateGlobal('image' + i)"
                        :aria-describedby="'input-image' + i + '-feedback'"
                        drop-placeholder="Arrastra un archivo aquí..."
                      ></b-form-file>
                      <b-input-group-append>
                        <b-button
                          :disabled="!form['imageURI' + i]"
                          variant="outline-danger"
                          size="sm"
                          @click="removeImage(i)"
                          ><b-icon icon="trash"
                        /></b-button>
                      </b-input-group-append>
                    </b-input-group>
                    <b-form-invalid-feedback id="input-image-feedback"
                      >Debes seleccionar una imagen válida (formato PNG o
                      JPEG).</b-form-invalid-feedback
                    > </b-form-group
                  ><b-form-group id="input-preview" class="col-12 text-center">
                    <div>
                      <img
                        style="max-height: 10rem"
                        :src="form['imageURI' + i]"
                      />
                    </div> </b-form-group></b-row
              ></b-col>
            </b-form-row>

            <b-row class="mt-5">
              <b-col :cols="12">
                <h4>Variaciones de producto</h4>
                <p>
                  La primera variación será la que aparecerá seleccionada por
                  defecto.
                </p>
              </b-col>

              <b-col :cols="12">
                <b-form-row
                  class="my-2"
                  v-for="(v, index) in $v.form.variations.$each.$iter"
                  :key="index"
                >
                  <b-col
                    sm="auto"
                    class="d-flex vertical-align"
                    align-self="center"
                  >
                    <div :for="`option-${index}`">Variación #{{ index }}</div>
                  </b-col>

                  <b-col sm="3" class="vertical-align">
                    <b-form-group
                      id="input-name"
                      class="col-12"
                      label="Nombre"
                      label-for="name"
                    >
                      <b-input-group>
                        <b-form-input
                          id="name"
                          v-model="v.name.$model"
                          :state="validateStateAttributes(index, 'name')"
                          aria-describedby="input-name-feedback"
                        ></b-form-input>

                        <b-input-group-append>
                          <b-button
                            v-if="index > 0"
                            variant="outline-primary"
                            size="sm"
                            @click="moveUp(index)"
                          >
                            <b-icon icon="arrow-up"></b-icon>
                          </b-button>
                          <b-button
                            v-if="index < form.variations.length - 1"
                            variant="outline-primary"
                            size="sm"
                            @click="moveDown(index)"
                          >
                            <b-icon icon="arrow-down"></b-icon>
                          </b-button>
                          <b-button size="sm" @click="removeAttribute(index)"
                            >Eliminar</b-button
                          >
                        </b-input-group-append>
                      </b-input-group>
                      <b-form-invalid-feedback
                        :state="validateStateAttributes(index, 'name')"
                        :id="`input-name-option-${index}`"
                        >Este campo es obligatorio.</b-form-invalid-feedback
                      >
                    </b-form-group>
                  </b-col>

                  <b-col sm="2">
                    <b-form-group
                      class="m-0"
                      label="Precio"
                      :id="`input-group-option-${index}`"
                      :label-for="`option-${index}`"
                    >
                      <b-form-input
                        :id="`option-${index}`"
                        @change="setDecimal(index, 'price', $event)"
                        :value="v.price.$model.replace('.', ',')"
                        :state="validateStateAttributes(index, 'price')"
                        :aria-describedby="`input-price-option-${index}`"
                      ></b-form-input>
                      <b-form-invalid-feedback
                        :state="validateStateAttributes(index, 'name')"
                        :id="`input-name-option-${index}`"
                        >Este campo es obligatorio.</b-form-invalid-feedback
                      >
                    </b-form-group>
                  </b-col>
                </b-form-row>

                <b-row class="mb-2">
                  <b-col sm="3" class="vertical-align">
                    <span
                      ><b-button type="button" size="sm" @click="addAttribute"
                        >Añadir
                        {{ form.variations.length > 0 ? 'nueva' : '' }}
                        variación</b-button
                      ></span
                    >
                  </b-col>
                </b-row>
              </b-col>
            </b-row>

            <b-row class="mt-5">
              <b-col cols="12">
                <b-button type="submit" variant="primary">
                  {{
                    id === 'new' ? 'Guardar nuevo producto' : 'Guardar producto'
                  }}</b-button
                >
              </b-col>
            </b-row>
          </b-form>
          <!-- /Form -->
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import {
  required,
  minLength,
  decimal,
  numeric,
  requiredIf,
  minValue,
} from 'vuelidate/lib/validators';

import { actions } from '@/admin/api.js';

import store from '@/admin/store.js';
import { validationMixin } from 'vuelidate';

import { helpers } from 'vuelidate/lib/validators';
import { VueEditor } from 'vue2-editor';
const isValidImage = (image) =>
  !helpers.req(image) || ['image/jpeg', 'image/png'].includes(image['type']);

export default {
  name: 'AdminPredefinedProductsEditScreen',
  props: ['id'],
  components: { VueEditor },
  mixins: [validationMixin],
  validations() {
    let rules = {
      reference: {},
      slug: {},
      description: {},

      hidden: {
        required,
      },

      is_discontinued: { required },

      // selector_size: {},
      // price: {
      //   required,
      //   decimal,
      //   minValue: minValue(0.0),
      // },
      category: {
        required,
      },

      image0: {
        isValidImage,
      },
      image1: {
        isValidImage,
      },
      image2: {
        isValidImage,
      },
      image3: {
        isValidImage,
      },
      image4: {
        isValidImage,
      },
      variations: {
        $each: {
          name: { required },
          price: { required, decimal, minValue: minValue(0.0) },
        },
      },
    };

    this.languageCodes.map((x) => {
      // Only 'es' lang required
      rules['reference_' + x] = { required };
      rules['slug_' + x] = { required };

      rules['description_' + x] = x === 'es' ? {} : {};
    });

    return {
      form: rules,
    };
  },
  data() {
    let form = {
      reference: '',
      slug: '',

      price: '0.0',
      category: null,
      image0: null,
      imageURI0: null,
      image1: null,
      imageURI1: null,
      image2: null,
      imageURI2: null,
      image3: null,
      imageURI3: null,
      image4: null,
      imageURI4: null,
      // selector_size: null,
      variations: [], // offline
      description: '', // offline

      hidden: false,
      is_discontinued: false,

      error: {
        show: false,
        text: '',
      },
    };

    store.getLanguageCodes().map((x) => {
      form['reference_' + x] = '';
      form['slug_' + x] = '';
      form['description_' + x] = '';

      // form['description_' + x] = '';
    });

    return {
      sharedState: store.state,
      languageCodes: store.getLanguageCodes(),
      languageNames: store.getLanguageNames(),
      categoryOptions: [],
      form: form,
      numImages: 5,
      attributeSelectorOptions: {},
      attributeSelectorDefaultOptions: {},
    };
  },
  computed: {
    numFiles() {
      return [...Array(this.numImages).keys()];
    },
  },
  created() {
    let promises = [];

    promises.push(actions.getPredefinedProductCategoriesUnpaginated());

    Promise.all(promises).then((x) => {
      // 0
      this.categoryOptions = x[0].data.results.map((y) => {
        return {
          value: y.id,
          text: (y.parent_name ? y.parent_name + ', ' : '') + y.reference,
        };
      });

      let self = this;

      if (this.id === 'new') {
      } else {
        actions.getPredefinedProduct(this.id).then((y) => {
          const data = y.data;

          this.form.reference = data.reference;
          this.form.slug = data.slug;
          this.form.description = data.description;
          this.form.hidden = data.hidden;
          this.form.is_discontinued = data.is_discontinued;

          this.languageCodes.map((y) => {
            this.form['reference_' + y] = data['reference_' + y];
            this.form['slug_' + y] = data['slug_' + y];

            this.form['description_' + y] = data['description_' + y];
          });

          this.form.variations = data.variations;
          this.form.category = data.category;
          this.form.imageURI0 = data.image0;
          this.form.imageURI1 = data.image1;
          this.form.imageURI2 = data.image2;
          this.form.imageURI3 = data.image3;
          this.form.imageURI4 = data.image4;
        });
      }
    });
  },
  methods: {
    removeImage(i) {
      this.form['image' + i] = null;
      this.form['imageURI' + i] = null;
    },
    swapAttributes(i, j) {
      this.form.variations[i] = this.form.variations.splice(
        j,
        1,
        this.form.variations[i]
      )[0];
    },
    moveUp(i) {
      i = parseInt(i);
      this.swapAttributes(i, i - 1);
    },
    moveDown(i) {
      i = parseInt(i);
      this.swapAttributes(i, i + 1);
    },
    capitalizeWords(string) {
      return string.replace(/(?:^|\s)\S/g, function (a) {
        return a.toUpperCase();
      });
    },
    changedName(val) {
      this.$v.form.reference.$model = this.capitalizeWords(val);
    },

    validateStateAttributes(index, name) {
      const { $dirty, $error } = this.$v.form.variations.$each.$iter[index][
        name
      ];
      return $dirty ? !$error : null;
    },

    /* Global */

    removeAttribute(index) {
      this.form.variations.splice(index, 1);
    },

    addAttribute() {
      this.form.variations.push({ name: '', price: '0.0' });
    },

    setDecimal(index, name, val) {
      val = val.replace('.', ''); // remove thousands
      val = val.replace(',', '.'); // replace comma by dot
      this.$v.form.variations.$each.$iter[index][name].$model = val;
      this.$v.form.variations.$each.$iter[index][name].$touch();
    },

    getDataURIFromFile(file) {
      return new Promise((resolve, reject) => {
        const fileReader = new FileReader();
        fileReader.onload = () => resolve(fileReader.result);
        fileReader.readAsDataURL(file);
      });
    },
    changedImage(i, newFile) {
      this.getDataURIFromFile(newFile).then((result) => {
        this.form['imageURI' + i] = result;
      });
    },
    validateStateGlobal(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },

    onSubmit() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      }

      let data = new FormData();

      if (this.form.image0 !== null) {
        data.append('image0', this.form.image0);
      } else if (this.form.imageURI0 === null) {
        data.append('image0', new File([], ''));
      }

      if (this.form.image1 !== null) {
        data.append('image1', this.form.image1);
      } else if (this.form.imageURI1 === null) {
        data.append('image1', new File([], ''));
      }

      if (this.form.image2 !== null) {
        data.append('image2', this.form.image2);
      } else if (this.form.imageURI2 === null) {
        data.append('image2', new File([], ''));
      }

      if (this.form.image3 !== null) {
        data.append('image3', this.form.image3);
      } else if (this.form.imageURI3 === null) {
        data.append('image3', new File([], ''));
      }

      if (this.form.image4 !== null) {
        data.append('image4', this.form.image4);
      } else if (this.form.imageURI4 === null) {
        data.append('image4', new File([], ''));
      }

      data.append('reference', this.form.reference_es);
      data.append('slug', this.form.slug_es);
      data.append('description', this.form.description_es);

      this.languageCodes.map((x) => {
        data.append('reference_' + x, this.form['reference_' + x]);
        data.append('slug_' + x, this.form['slug_' + x]);

        data.append('description_' + x, this.form['description_' + x]);
      });

      data.append('hidden', this.form.hidden);
      data.append('is_discontinued', this.form.is_discontinued);

      data.append('variations', JSON.stringify(this.form.variations));
      if (this.form.category !== null) {
        data.append('category', parseInt(this.form.category));
      }

      if (this.id === 'new') {
        actions.postPredefinedProduct(data).then((x) => {
          this.$router.push({ name: 'AdminPredefinedProductsScreen' });
        });
      } else {
        actions.patchPredefinedProduct(this.id, data).then((x) => {
          this.$router.push({ name: 'AdminPredefinedProductsScreen' });
        });
      }

      store.setOverlayShow(true);
    },
  },
  mounted() {},
};
</script>

<style scoped></style>
